<template>
  <div>
    <n-list-title class="ml-3 mt-3" :text="$t('widgets.moduleSelection')"></n-list-title>

    <!-- Removed @focus="hideKeyboard()" because it made close the module selection -->
    <div>
      <v-chip
        class="ml-2 mb-1"
        dark
        small
        v-for="(module, ind) in modules"
        :class="isSelectedModule(module) ? 'selected-module' : 'grey'"
        :key="ind"
        @click="toggleModule(module)"
        ><v-avatar left v-if="isSelectedModule(module)">
          <v-icon>mdi-checkbox-marked-circle</v-icon>
        </v-avatar>
        {{ module.title }}</v-chip
      >
    </div>
    <div v-if="selectedModules.length === 0" class="caption pl-3">{{ $t('widgets.emptyModuleSelection') }}</div>
  </div>
</template>

<script>
import common from '@/mixins/common';
import NListTitle from '@/components/texts/NListTitle.vue';

export default {
  name: 'ModuleSelection',
  mixins: [common],
  components: {
    NListTitle,
  },
  props: {
    config: Object,
    value: Array,
    modules: Array, // Array of {type:'module type', name:'module title', instance:instance of the module
  },

  data() {
    return {
      selectedModules: this.value,
    };
  },
  methods: {
    toggleModule(module) {
      const index = this.selectedModules.findIndex((m) => m.instance === module.instance && m.type === module.type);
      if (index < 0) {
        this.selectedModules.push(module);
      } else {
        this.selectedModules.splice(index, 1);
      }
    },
    isSelectedModule(module) {
      const index = this.selectedModules.findIndex((m) => m.instance === module.instance && m.type === module.type);
      return index >= 0;
    },
  },

  watch: {
    value(newValue, oldValue) {
      this.selectedModules = newValue;
    },
    selectedModules(newValue) {
      console.debug('selectedModules changed');
      this.$emit('input', this.selectedModules);
    },
  },
};
</script>
<style scoped>
.theme--dark .selected-module {
  background: #646769;
}
.theme--light .selected-module {
  background: #6c7275;
}
</style>
